import Arrow from "images/arrow_down_red.svg";
import * as React from "react";
export const OverviewItem = ({ id, name }: { id: string; name: string }) => {
    const splitted = name.split(" ");
    const firstPart = splitted.slice(0, -1).join(" ") + " ";
    const lastPart = splitted.slice(-1).join(" ");
    return (
        <div className="mx-auto my-3">
            <a href={id} className="app-href text-lg decoration-transparent">
                <span>{firstPart}</span>
                <span className="inline-flex flex-wrap whitespace-nowrap">
                    {lastPart}
                    <img
                        src={Arrow}
                        className="relative top-[2px] ml-[10px] inline h-[24px] w-[24px]"
                    />
                </span>
            </a>
        </div>
    );
};
